export class ProvinciaDTO {
	idProvincia: string;
	siglaProvincia: string;
	provincia: string;
	denominazione: string;
	sigla: string;
}